import React, {useEffect, useState} from 'react'
import {PageTitle} from 'layout/master-layout'
// import {useTranslation} from 'react-i18next'
import Spinner from 'layout/common/Spinner'
import {useAuth} from 'context/AuthProvider'
import ManageUser from '../ManageUser'
import {IUserAction} from 'models/UserManagement'
import {UserAction} from '../UserAction'
import {useTranslation} from 'react-i18next'

type IProps = {
 hidePartent: boolean
 setHideParent: (newState: boolean) => void
}

const ManageUsersPage = (props: IProps) => {
 //  const {t} = useTranslation()
 //  const navigate = useNavigate()
 const {userData} = useAuth()
 const accessDetails =
  userData?.userSubModule?.userManagement
 const [loader, setLoader] = useState(false)
 const [actionDetails, setActionDetails] =
  useState<IUserAction | null>(null)

 useEffect(() => {
  if (actionDetails) {
   props.setHideParent(true)
  } else {
   props.setHideParent(false)
  }
 }, [actionDetails])

 return (
  <>
   {loader && <Spinner />}
   {actionDetails &&
    actionDetails.actionType === 'manage_user' && (
     <UserAction
      actionDetails={actionDetails}
      setActionDetails={setActionDetails}
      tabList={[
       {
        title: 'Manage User',
        id: 'manage_user',
        icon: '',
       },
      ]}
     />
    )}
   <div
    className={`${
     props.hidePartent ? 'hidden' : 'visible'
    } w-full min-h-full`}
   >
    <div className='my-6'>
     <ManageUser
      accessDetails={accessDetails}
      loggedInUserId={userData?.userId}
      actionDetails={actionDetails}
      setLoader={setLoader}
      setActionDetails={setActionDetails}
     />
    </div>
   </div>
  </>
 )
}

export default function ManageUsersPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 const [hidePartent, setHideParent] = useState(true)
 const {t} = useTranslation()
 return (
  <div className='container'>
   <div className='px-[72px] pt-6 pb-[200px] bg-white'>
    {!hidePartent && (
     <PageTitle
      breadcrumbContainerClass={
       'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
      }
      breadcrumbs={[
       {
        title: t('breadCrumbs.home'),
        path: '/home-page',
        isActive: false,
       },
       {
        title: t('breadCrumbs.userManagement'),
        path: '/user-management',
        isActive: false,
       },
       {
        title: t('breadCrumbs.manageUser'),
        path: '',
        isActive: true,
       },
      ]}
      description='Manage User'
     >
      Home
     </PageTitle>
    )}
    <ManageUsersPage
     hidePartent={hidePartent}
     setHideParent={setHideParent}
    />
   </div>
  </div>
 )
}
